var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlignSbVer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M216.005 15L40.005 15",
    stroke: "black",
    strokeWidth: 24,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M200 89L200 45C200 42.7909 196.418 41 192 41L156 41C151.582 41 148 42.7909 148 45L148 89C148 91.2091 151.582 93 156 93L192 93C196.418 93 200 91.2091 200 89Z",
    stroke: "black",
    strokeWidth: 24,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M110 89L110 45C110 42.7909 106.418 41 102 41L66 41C61.5817 41 58 42.7909 58 45L58 89C58 91.2091 61.5817 93 66 93L102 93C106.418 93 110 91.2091 110 89Z",
    stroke: "black",
    strokeWidth: 24,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M200 211.111L200 164.889C200 163.293 196.418 162 192 162L156 162C151.582 162 148 163.293 148 164.889L148 211.111C148 212.707 151.582 214 156 214L192 214C196.418 214 200 212.707 200 211.111Z",
    stroke: "black",
    strokeWidth: 24,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M110 211.111L110 164.889C110 163.293 106.418 162 102 162L66 162C61.5817 162 58 163.293 58 164.889L58 211.111C58 212.707 61.5817 214 66 214L102 214C106.418 214 110 212.707 110 211.111Z",
    stroke: "black",
    strokeWidth: 24,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M216.005 240L40.005 240",
    stroke: "black",
    strokeWidth: 24,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlignSbVer);
export default __webpack_public_path__ + "static/media/align-sb-ver.62fb2431c27c1612b431210eb3290834.svg";
export { ForwardRef as ReactComponent };